import script from "./DocumentList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentList.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentList.vue?vue&type=style&index=0&id=1bdfe46a&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bdfe46a"]])

export default __exports__